import { useEffect, useState } from "react";

import PasswordEyeClosedIcon from "~/assets/icons/PasswordEyeClosedIcon.svg?react";
import PasswordEyeOpenIcon from "~/assets/icons/PasswordEyeOpenIcon.svg?react";

import { Icon } from "../../../assets/icons/Icon";
import styles from "./MaskedText.module.scss";

const REDUNDANT_SYMBOLS = 2;

interface MaskedTextProps {
  text: string;
  message?: string;
}

const MaskedText = ({ text }: MaskedTextProps) => {
  const [visible, setVisible] = useState(false);
  const [isCopied, setIsCopied] = useState(false);

  const toggleVisibility = () => {
    setVisible((prev) => !prev);
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setIsCopied(true);
    } catch (err) {
      console.error(err);
      setIsCopied(false);
    }
  };
  useEffect(() => {
    if (isCopied) {
      setTimeout(() => {
        setIsCopied(false);
      }, 3000);
    }
  }, [isCopied]);

  return (
    <div className={styles.maskedText}>
      <span className={styles.maskedTextText}>
        {visible ? text : "•".repeat(text.length - REDUNDANT_SYMBOLS)}
      </span>

      <button onClick={toggleVisibility} className={styles.button}>
        {visible ? <PasswordEyeOpenIcon /> : <PasswordEyeClosedIcon />}
      </button>

      <button onClick={copyToClipboard} className={styles.button}>
        <Icon iconName={isCopied ? "CheckmarkIcon" : "CopyIcon"} />
      </button>
    </div>
  );
};

export default MaskedText;
